if ($("#covid-request").length) {
  $(document).ready(function() {
    var structure_type_value = $("#structure_structure_type").val() || "eple";

    $(".eple-documents, .occe-documents").addClass("hidden");
    $("input", ".eple-documents, .occe-documents").prop("disabled", true);
    $("." + structure_type_value, "#step-3").removeClass("hidden");
    $("input", "." + structure_type_value).prop("disabled", false);

    $("#structure_structure_type").on("change", function() {
      var value = $(this).val() || "eple";

      $(".eple-documents, .occe-documents").addClass("hidden");
      $("input", ".eple-documents, .occe-documents").prop("disabled", true);
      $("." + value, "#step-3").removeClass("hidden");
      $("input", "." + value).prop("disabled", false);
    })

    $(".file-upload-field").on("change", function() {
      $(this).parent(".file-upload-wrapper").attr("data-text", $(this).val().replace(/.*(\/|\\)/, ""));
    });

    $(".btn-continue, .breadcrumb-link").on("click", function(event) {
      if ($(this).hasClass("submit-form") === false) {
        var step_id = $(this).data("step");

        if ($(this).hasClass('btn-continue') && $(this).data('step') === 'step-1') {
          var accepted_chart_input = $($('input', '#step-0')[0]);

          if (!accepted_chart_input.prop('checked')) {
            return event.preventDefault();
          }
        }

        $(".container-step, .breadcrumb li").removeClass("active");
        $("#" + step_id + ", ." + step_id).addClass("active");
      }
    });

    var form = document.getElementById('new_structure');

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      if ($("#step-3.active").length === 0) {
        return false;
      }

      var hiddenInput = document.getElementById('g-recaptcha-response-data-covid-request');
      var response = await window.executeRecaptchaForCovidRequestAsync();
      hiddenInput.value = response;
      form.submit();
    });
  });
}
